export default __webpack_public_path__ + "static/media/042-oriental pearl tower.ded9edd1.svg";